"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-sdk/utils/mergeWithCollectionOfType"));

var _actions = require("./actions");

var _SubscriptionDefinition = _interopRequireDefault(require("./SubscriptionDefinition"));

var _handleActions;

var initialState = (0, _immutable.OrderedMap)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchSubscriptionDefinitionsActionTypes.SUCCESS, function (state, action) {
  var data = action.payload.data.map(function (definition) {
    definition.subscriptionDefinition.translations = definition.translations;
    definition = definition.subscriptionDefinition;
    return definition;
  });
  return (0, _mergeWithCollectionOfType.default)(_SubscriptionDefinition.default, data, state);
}), (0, _defineProperty2.default)(_handleActions, _actions.CreateSubscriptionDefinitionActionTypes.SUCCESS, function (state, action) {
  return state.set(action.payload.data.id, new _SubscriptionDefinition.default(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.CreateSubscriptionTranslationActionTypes.SUCCESS, function (state, action) {
  var subscriptionId = action.payload.data.subscriptionId;

  var _state$get$toJS = state.get(subscriptionId).toJS(),
      translations = _state$get$toJS.translations;

  translations.push(action.payload.data);
  return state.setIn([subscriptionId, 'translations'], translations);
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateSubscriptionDefinitionActionTypes.SUCCESS, function (state, action) {
  var _action$payload$props = action.payload.props,
      subscriptionDefinition = _action$payload$props.subscriptionDefinition,
      translations = _action$payload$props.translations;
  var data = (0, _extends2.default)({}, subscriptionDefinition, {
    translations: translations
  });
  var subscriptionId = subscriptionDefinition.id;
  return state.set(subscriptionId, new _SubscriptionDefinition.default(data));
}), (0, _defineProperty2.default)(_handleActions, _actions.DeleteSubscriptionTranslationActionTypes.REQUEST, function (state, action) {
  var _action$payload$data = action.payload.data,
      subscriptionId = _action$payload$data.subscriptionId,
      languageCode = _action$payload$data.languageCode;
  return state.withMutations(function (s) {
    var translations = s.getIn([subscriptionId, 'translations']);
    var translationIndex = translations.findIndex(function (translation) {
      return translation.languageCode === languageCode;
    });
    translations.splice(translationIndex, 1);
    var languageCodes = s.getIn([subscriptionId, 'languageCodes']).delete(languageCode);
    return s.setIn([subscriptionId, 'languageCodes'], languageCodes).setIn([subscriptionId, 'translations'], translations);
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;